module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/background_desktop-ee1c4956816d16b9cbdfe64bd6c9bec4.jpg";